import { DELETE_MANCHESTER_DETAILS_SUCCESS, DELETE_MANCHESTER_DETAILS_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case DELETE_MANCHESTER_DETAILS_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case DELETE_MANCHESTER_DETAILS_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
